import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './styles/userForm.scss';
import './styles/tabs.scss';
import settingsPlugin from '../../core/settingsPlugin';
import { USER_ROLES } from '../../state/selectedUser/constants';

export class UserFormContainer extends Component {
  state = {
    isModalOpen: false
  };

  containerRef = React.createRef();

  onChangeEnv = (e) => {
    this.props.setPreset(e.target.value);
  };

  onClose = () => {
    this.props.close();
  };

  getDomNode = () => this.containerRef.current;

  onSignin = (data) => {
    const { signIn } = this.props;
    signIn();
  }

  onManageAccess = () => {
    this.props.history.push('/adminPanel');
  }

  onSignout = async (data) => {
    const { settings } = this.props;
    const preset = "Platform Credential"; // only signout for platform credential
    const { type, token, authEndpoint } = settings[preset];

    const { signOut } = settingsPlugin.get(type);

    await signOut(token, authEndpoint);
  }

  onChange = (data) => {
    const { title, addSettings, preset, settings } = this.props;
    if (settings.hasOwnProperty(preset) && settings[preset].editable) {
      addSettings(title, preset, { ...settings[preset], editable: false });
    }
  };

  onChangeName = (e) => {
    const { value } = e.target;
    const { changeSettingsName, title, preset } = this.props;

    if (value !== preset) {
      changeSettingsName(title, preset, value);
    }
  };

  openModal = () => {
    this.setState({
      isModalOpen: true,
    });
  };

  closeModal = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  onAddSettings = (name, type) => {
    const { addSettings, title } = this.props;
    addSettings(title, name, { type, isCustom: true });
  };

  deleteSettings = () => {
    const { preset, title, deleteSettings, settings } = this.props;
    deleteSettings(title, preset, Object.keys(settings)[0]);
  };

  duplicateSettings = () => {
    const { preset, title, addSettings, settings } = this.props;
    let name = `${preset} copy`;
    const presetNames = Object.keys(settings);
    while (presetNames.indexOf(name) !== -1) {
      name = `${name} copy`;
    }
    addSettings(title, name, { ...settings[preset], isCustom: true });
  };

  onSaveDefault = () => {
    const { title, preset, setDefaultPreset, setNotification } = this.props;
    setDefaultPreset(title, preset);
    setNotification({
      message: `Default preset "${preset}" has been set for module "${title}"`,
      impact: 'positive',
      autoDismiss: 4,
    });
  };

  getUsrSettings = () => {
    const { settings, preset, loggedin, user = {}, userCatalogInfo } = this.props;
    const { isCustom } = settings[preset];
    const { email } = user;

    const actions = [{ label: 'Duplicate', callback: this.duplicateSettings }];
    if (isCustom) {
      actions.push({ label: 'Delete', callback: this.deleteSettings });
    }

    return (
      <div
        className="rf-nav-tabs__tab__caption__actions__dropdown rf-login-logout" 
      >
        {!loggedin && (<div
          className="rf-nav-tabs__tab__caption__actions__dropdown__item rf-item"
          onClick={this.onSignin}
        >
          Sign in
        </div>)}
        {loggedin && (<div
          className="rf-nav-tabs__tab__caption__actions__dropdown__item rf-item-email"
        >
          {email}
        </div>)}
        {loggedin && (<div
          className="rf-nav-tabs__tab__caption__actions__dropdown__item rf-item-realm"
        >
          realm: org903589868
        </div>)}
        {loggedin  && (userCatalogInfo?.roles[0]=== USER_ROLES.SUPERADMIN) &&  (
          <div
          className="rf-nav-tabs__tab__caption__actions__dropdown__item rf-item"
            onClick={() => window.location.href = '/admin'}>
            Manage Access
          </div>
      )}
        {loggedin && (<div
          className="rf-nav-tabs__tab__caption__actions__dropdown__item rf-item"
          onClick={this.onSignout}
        >
          Sign out
        </div>)}
        <div
          className="rf-nav-tabs__tab__caption__actions__dropdown__item"
          // onClick={this.onAction.bind(this, this.openColorModal)}
        >
          <a
            className="rf-item"
            href="https://developer.here.com/"
            target="blank"
          >
            Help
          </a>
        </div>
        <div
          className="rf-nav-tabs__tab__caption__actions__dropdown__item"
          // onClick={this.onAction.bind(this, this.openColorModal)}
        >
          <a
            className="rf-item"
            href={`https://${window.location.host}/changes`}
            target="blank"
          >
            Change logs
          </a>
        </div>
      </div>
    )
  };

  render() {
    const { isUserShown } = this.props;
    const formClasses = classnames({
      'rf-user-form': true,
      'rf-user-form_fadein': isUserShown,
    });

    return (
      <div className={formClasses} ref={this.containerRef}>
        {this.getUsrSettings()}
      </div>
    );
  }
}

UserFormContainer.defaultPros = {
  canResetCredentials: true,
};

UserFormContainer.propTypes = {
  isUserShown: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  settings: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  setPreset: PropTypes.func.isRequired,
  preset: PropTypes.string.isRequired,
  addSettings: PropTypes.func.isRequired,
  deleteSettings: PropTypes.func.isRequired,
  changeSettingsName: PropTypes.func.isRequired,
  setDefaultPreset: PropTypes.func.isRequired,
  setNotification: PropTypes.func.isRequired,
  waitingWorker: PropTypes.object,
};

export default UserFormContainer;
